var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import * as AccountResources from "../../../constants/accountResourceNames";
import { HUMO, EXPAY_SUB_TOKEN_OPTIONS } from "../../../constants/expaySubToken";
var messages = defineMessages({
    continue: {
        id: "recharge.continue",
        defaultMessage: "Продолжить"
    },
    required: {
        id: "recharge.required",
        defaultMessage: "Обязательное поле"
    },
    number: {
        id: "withdraw.number",
        defaultMessage: "Должно состоять из цифр"
    }
});
var MIN_AMOUNT = 30000;
var MAX_AMOUNT = 33915000;
var PRESET_AMOUNTS = [30000, 50000, 150000, 300000, 500000];
var SUB_TOKEN_KEY = "expay_withdraw_sub_token";
var getInitialSubToken = function () {
    var stored = localStorage.getItem(SUB_TOKEN_KEY);
    if (stored === null) {
        return HUMO;
    }
    var parsed = Number(stored);
    return EXPAY_SUB_TOKEN_OPTIONS.some(function (option) { return option.value === parsed; })
        ? parsed
        : HUMO;
};
var formatNumber = function (num) {
    var value = Number(String(num).replace(/\D/g, ""));
    if (isNaN(value)) {
        return "";
    }
    return Intl.NumberFormat("ru").format(value);
};
var parseAmount = function (value) {
    return Number(String(value != null ? value : "").replace(/\D/g, ""));
};
var formatCardNumber = function (value) {
    return String(value)
        .replace(/\D/g, "")
        .slice(0, 16)
        .replace(/(\d{4})(?=\d)/g, "$1 ");
};
function luhnCheck(value) {
    if (/[^0-9-\s]+/.test(value))
        return false;
    var nCheck = 0, bEven = false;
    value = value.replace(/\D/g, "");
    for (var n = value.length - 1; n >= 0; n--) {
        var cDigit = value.charAt(n), nDigit = parseInt(cDigit, 10);
        if (bEven && (nDigit *= 2) > 9)
            nDigit -= 9;
        nCheck += nDigit;
        bEven = !bEven;
    }
    return (nCheck % 10) == 0;
}
var isValidCardNumber = function (value) {
    var digits = String(value).replace(/\D/g, "");
    if (digits.length !== 16) {
        return false;
    }
    return luhnCheck(digits);
};
var UzcardForm = /** @class */ (function (_super) {
    __extends(UzcardForm, _super);
    function UzcardForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.required = function (value) {
            if (value) {
                return undefined;
            }
            return _this.props.intl.formatMessage(messages.required);
        };
        _this.number = function (value) {
            if (!value) {
                return undefined;
            }
            var digits = String(value).replace(/\D/g, "");
            if (!digits || isNaN(Number(digits))) {
                return _this.props.intl.formatMessage(messages.number);
            }
            return undefined;
        };
        _this.cardNumber = function (value) {
            if (!value) {
                return undefined;
            }
            if (!isValidCardNumber(value)) {
                return _this.props.intl.formatMessage({ id: "withdraw.card_invalid" });
            }
            return undefined;
        };
        _this.minValue = function (value) {
            var amount = parseAmount(value);
            if (value && amount < MIN_AMOUNT) {
                return _this.props.intl.formatMessage({ id: "recharge.min_value" }, { min: formatNumber(MIN_AMOUNT) });
            }
            return undefined;
        };
        _this.maxValue = function (value) {
            var amount = parseAmount(value);
            if (value && amount > MAX_AMOUNT) {
                return _this.props.intl.formatMessage({ id: "recharge.max_value" }, { max: formatNumber(MAX_AMOUNT) });
            }
            return undefined;
        };
        _this.submit = function (values) {
            var payload = {
                CardNumber: String(values.CardNumber).replace(/\D/g, ""),
                Amount: parseAmount(values.Amount),
                ResourceId: AccountResources.UZ,
                Subtoken: Number(values.Subtoken),
                Password: values.Password
            };
            _this.props.submitAction(payload);
        };
        _this.renderSubTokenField = function (_a) {
            var input = _a.input;
            return (_jsx("div", __assign({ className: "input input-select" }, { children: _jsx("select", __assign({ value: input.value, onChange: function (e) {
                        var subtoken = Number(e.target.value);
                        localStorage.setItem(SUB_TOKEN_KEY, String(subtoken));
                        input.onChange(subtoken);
                    }, onBlur: input.onBlur }, { children: EXPAY_SUB_TOKEN_OPTIONS.map(function (option) { return (_jsx("option", __assign({ value: option.value }, { children: _this.props.intl.formatMessage({ id: option.messageId }) }), option.value)); }) })) })));
        };
        _this.renderCardField = function (_a) {
            var input = _a.input, placeholder = _a.placeholder, _b = _a.meta, touched = _b.touched, error = _b.error;
            var inputCls = touched && error ? "input error" : "input";
            var displayValue = formatCardNumber(input.value);
            return (_jsxs("div", __assign({ className: inputCls }, { children: [_jsx("input", { type: "tel", inputMode: "numeric", maxLength: 19, placeholder: placeholder, autoComplete: "off", value: displayValue, onChange: function (e) {
                            var parsed = e.target.value.replace(/\D/g, "").slice(0, 16);
                            input.onChange(parsed);
                        }, onBlur: input.onBlur, onFocus: input.onFocus }), touched && error && _jsx("div", __assign({ className: "error" }, { children: error }))] })));
        };
        _this.renderPasswordField = function (_a) {
            var input = _a.input, placeholder = _a.placeholder, errorCode = _a.errorCode, _b = _a.meta, touched = _b.touched, error = _b.error;
            var passwordError = errorCode === -7 || errorCode === -400
                ? _this.props.intl.formatMessage({
                    id: "withdraw.withdraw_form_wrong_password"
                })
                : null;
            var inputCls = (touched && error) || passwordError ? "input error" : "input";
            return (_jsxs("div", __assign({ className: inputCls }, { children: [_jsx("input", __assign({}, input, { type: "password", placeholder: placeholder, autoComplete: "new-password" })), touched && error && _jsx("div", __assign({ className: "error" }, { children: error })), passwordError && _jsx("div", __assign({ className: "error" }, { children: passwordError }))] })));
        };
        _this.renderAmountField = function (_a) {
            var input = _a.input, placeholder = _a.placeholder, _b = _a.meta, touched = _b.touched, error = _b.error;
            var inputCls = touched && error ? "input error" : "input";
            var rawDigits = String(input.value != null ? input.value : "").replace(/\D/g, "");
            var displayValue = rawDigits ? formatNumber(rawDigits) : "";
            return (_jsxs("div", __assign({ className: inputCls }, { children: [_jsx("input", { type: "tel", inputMode: "numeric", placeholder: placeholder, value: displayValue, onChange: function (e) {
                            var parsed = e.target.value.replace(/\D/g, "").slice(0, 8);
                            input.onChange(parsed);
                        }, onBlur: input.onBlur, onFocus: input.onFocus }), _jsx("div", __assign({ className: "placeholder" }, { children: "UZS" })), touched && error && _jsx("div", __assign({ className: "error" }, { children: error }))] })));
        };
        return _this;
    }
    UzcardForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, handleSubmit = _a.handleSubmit, fetching = _a.fetching, intl = _a.intl, amountValue = _a.amountValue, cardNumberValue = _a.cardNumberValue, passwordValue = _a.passwordValue, invalid = _a.invalid, commission = _a.commission, errorCode = _a.errorCode;
        var numericAmount = parseAmount(amountValue);
        var isSubmitDisabled = invalid ||
            fetching ||
            !cardNumberValue ||
            !amountValue ||
            !passwordValue ||
            numericAmount < MIN_AMOUNT ||
            numericAmount > MAX_AMOUNT ||
            !isValidCardNumber(cardNumberValue);
        return (_jsx("form", __assign({ id: "withdraw-bank-card", onSubmit: handleSubmit(this.submit) }, { children: _jsxs("div", __assign({ className: "wrapper" }, { children: [_jsx("p", __assign({ className: "usdt-form__title", style: { marginBottom: "8px" } }, { children: _jsx(FormattedMessage, { id: "withdraw.expay.min_amount" }) })), _jsx("p", __assign({ className: "usdt-form__descr", style: { marginBottom: "22px" } }, { children: _jsx(FormattedMessage, { id: "withdraw.expay.max_amount" }) })), _jsx("p", __assign({ className: "usdt-form__title", style: { marginBottom: "8px" } }, { children: _jsx(FormattedMessage, { id: "expay.choose_card_type" }) })), _jsx(Field, { component: this.renderSubTokenField, name: "Subtoken" }), _jsx(Field, { component: this.renderCardField, name: "CardNumber", placeholder: intl.formatMessage({ id: "recharge.card_number" }), validate: [this.required, this.cardNumber] }), _jsx(Field, { component: this.renderAmountField, name: "Amount", placeholder: intl.formatMessage({
                            id: "withdraw.expay.amount_placeholder"
                        }), validate: [this.required, this.number, this.minValue, this.maxValue] }), _jsx("div", __assign({ className: "grid" }, { children: PRESET_AMOUNTS.map(function (preset) { return (_jsx("div", __assign({ className: String(preset) === String(amountValue)
                                ? "grid_control active"
                                : "grid_control", onClick: function () { return _this.props.change("Amount", String(preset)); }, onKeyDown: function (e) {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    _this.props.change("Amount", String(preset));
                                }
                            }, role: "button", tabIndex: 0, "aria-label": formatNumber(preset) }, { children: formatNumber(preset) }), preset)); }) })), _jsx(Field, { component: this.renderPasswordField, name: "Password", errorCode: errorCode, placeholder: intl.formatMessage({ id: "sign_in.password" }), validate: [this.required] }), _jsx("div", __assign({ className: "comissionBlock" }, { children: _jsxs("p", { children: [_jsx(FormattedMessage, { id: "withdraw.commission" }), ":", " ", _jsxs("span", __assign({ style: { fontWeight: 700 } }, { children: [formatNumber(commission), " UZS"] }))] }) })), _jsx("div", __assign({ className: "controls" }, { children: fetching ? (_jsx("button", { disabled: true, className: "singlebet_submit loading", type: "button" })) : (_jsx("button", __assign({ type: "submit", disabled: isSubmitDisabled, className: "singlebet_submit" }, { children: _jsx(FormattedMessage, __assign({}, messages.continue)) }))) }))] })) })));
    };
    return UzcardForm;
}(React.Component));
UzcardForm.propTypes = {
    rates: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    submitAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    change: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    commission: PropTypes.number.isRequired,
    errorCode: PropTypes.number
};
UzcardForm = reduxForm({
    form: "withdraw-paybox",
    initialValues: {
        Subtoken: getInitialSubToken()
    }
})(UzcardForm);
var selector = formValueSelector("withdraw-paybox");
var getCommission = function (providers) {
    if (providers === void 0) { providers = []; }
    var expayProvider = providers.find(function (provider) { return provider.Id === 21 || provider.ProviderId === 21; });
    if (!expayProvider) {
        return 0;
    }
    return expayProvider.Commission || expayProvider.Fee || 0;
};
UzcardForm = connect(function (state) { return ({
    amountValue: selector(state, "Amount"),
    cardNumberValue: selector(state, "CardNumber"),
    passwordValue: selector(state, "Password"),
    commission: getCommission(state.withdraw.get("providers"))
}); })(UzcardForm);
export default injectIntl(UzcardForm);



// WEBPACK FOOTER //
// ./src/components/withdraw/forms/UzcardForm.jsx